'use client';

import type * as React from 'react';
import Link from 'next/link';
import { BreadcrumbSchema } from '@/lib/schema';
import { cn } from '@/lib/utils';

interface BreadcrumbsProperties extends React.HTMLAttributes<HTMLDivElement> {
  items: {
    label: string;
    href: string;
  }[];
}

export function Breadcrumbs({ items, className, ...properties }: BreadcrumbsProperties) {
  // Always include Home as the first item
  const breadcrumbItems = [{ label: 'Home', href: '/' }, ...items];

  const origin = globalThis.window === undefined ? '' : globalThis.location.origin;

  return (
    <>
      {/* Visible Breadcrumbs */}
      <nav
        className={cn('flex items-center space-x-2 text-sm', className)}
        aria-label="Breadcrumb"
        {...properties}
      >
        <ol className="flex items-center">
          {breadcrumbItems.map((item, index) => (
            <li key={item.href} className="flex items-center">
              {index > 0 && <span className="mx-2 text-muted-foreground">/</span>}
              {index === breadcrumbItems.length - 1 ? (
                <span className="font-medium text-white/90">{item.label}</span>
              ) : (
                <Link
                  href={item.href}
                  className="decoration text-white/70 transition-colors hover:underline"
                >
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>

      {/* Schema.org BreadcrumbList structured data */}
      <BreadcrumbSchema
        items={breadcrumbItems.map((item) => ({
          name: item.label,
          item: `${origin}${item.href}`,
        }))}
      />
    </>
  );
}
